import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';

import * as ApexCharts from 'apexcharts';

declare var require: any;
var Highcharts = require('highcharts/highmaps.js');
import Exporting from 'highcharts/modules/exporting';
import funnel from 'highcharts/modules/funnel';
import { ActivatedRoute, Router } from '@angular/router';
Exporting(Highcharts);
funnel(Highcharts);

@Component({
	selector: 'app-global-performance',
	templateUrl: './global-performance.component.html',
	styleUrls: ['./global-performance.component.scss']
})
export class GlobalPerformanceComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
  ) { }

	// page_tabs: any = [
  //   {
  //     name: "Wealth",
  //     business_area: 5
  //   },
  //   {
  //     name: "Deposits",
  //     business_area: 6
  //   },
  //   {
  //     name: "Lending",
  //     business_area: 7
  //   },
  //   {
  //     name: "Insurance",
  //     business_area: 8
  //   },
  // ];
	selected_duration_filter: any = "ytd";

  user_details: any;

	ngOnInit(): void {
    // this.selected_page_tab = this.page_tabs[0];
    this.user_details = this.storageService.get("user_details");
		this.getBusinessAreaData();
	}

  page_tabs: any = [];
  getBusinessAreaData() {
    this.commonService.getData('/businessarea/?no_page=true').subscribe(
			(res: any) => {
				this.page_tabs = res;
        if (this.page_tabs.length > 0) {
          this.selected_page_tab = this.page_tabs[0];
          this.getPageData();
        }
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
  }

	page_data: any;
	page_data_loaded: boolean = false;
	getPageData() {
    this.page_data_loaded = false;
    this.commonService.getData('/comparisionDashboard/?selected_duration=' + this.selected_duration_filter + '&business_area=' + this.selected_page_tab.id).subscribe(
			(res: any) => {
				this.page_data = res['data'];

        setTimeout(() => {
          this.createApplicationFunnel();
          this.createTraditionalFunnel();

          if (this.selected_page_tab.id == 5) {
            this.createAdvisorProductivityGraph();
          }

          this.createClientEngagementGraph();

          this.createRevenueImpactGraph();

        }, 200);

				this.page_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);

	}

  selected_page_tab: any;
  changePageTab(data) {
    this.selected_page_tab = JSON.parse(JSON.stringify(data));
    this.getPageData();
  }

  @ViewChild('applicationFunnel', { read: ElementRef }) applicationFunnel: ElementRef;
    createApplicationFunnel() {
    let $this = this;
    Highcharts.chart(this.applicationFunnel.nativeElement, {
      chart: {
        type: 'funnel',
      },
      // colors: ["#4ED9A7", "#FE8E6B", "#FFB800", "#757575"],
      colors: ['#DC661D', '#c69983', '#D49E18', '#7fC310', '#028E94'],
      exporting: {
        enabled: false,
      },
      title: {
        text: '',
      },
      plotOptions: {
        series: {
          cursor: 'pointer',
          // events: {
          //     click: function (event) {
          //       $this.selected_funnel_type = event.point.name;
          //       $this.selected_funnel_broker = "All";
          //       $this.getTableGraphsData();
          //     }
          // },
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b> ({point.y:,.0f})',
            softConnector: true,
          },
          center: ['40%', '50%'],
          neckWidth: '20%',
          neckHeight: '0%',
          width: '80%',
        },
      },
      legend: {
        enabled: false,
      },
      series: [
        {
          name: '',
          data: this.page_data['app_sales_funnel']
        },
      ],
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              plotOptions: {
                series: {
                  dataLabels: {
                    inside: true,
                  },
                  center: ['50%', '50%'],
                  width: '100%',
                },
              },
            },
          },
        ],
      },
    });
    }

    @ViewChild('traditionalFunnel', { read: ElementRef }) traditionalFunnel: ElementRef;
    createTraditionalFunnel() {
		let $this = this;
    Highcharts.chart(this.traditionalFunnel.nativeElement, {
      chart: {
        type: 'funnel',
      },
      // colors: ["#4ED9A7", "#FE8E6B", "#FFB800", "#757575"],
      colors: ['#DC661D', '#c69983', '#D49E18', '#7fC310', '#028E94'],
      exporting: {
        enabled: false,
      },
      title: {
        text: '',
      },
      plotOptions: {
        series: {
          cursor: 'pointer',
          // events: {
          //     click: function (event) {
          //       $this.selected_funnel_type = event.point.name;
          //       $this.selected_funnel_broker = "All";
          //       $this.getTableGraphsData();
          //     }
          // },
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b> ({point.y:,.0f})',
            softConnector: true,
          },
          center: ['40%', '50%'],
          neckWidth: '20%',
          neckHeight: '0%',
          width: '80%',
        },
      },
      legend: {
        enabled: false,
      },
      series: [
        {
          name: '',
          data: this.page_data['traditional_sales_funnel']
        },
      ],
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              plotOptions: {
                series: {
                  dataLabels: {
                    inside: true,
                  },
                  center: ['50%', '50%'],
                  width: '100%',
                },
              },
            },
          },
        ],
      },
    });
  }

  createAdvisorProductivityGraph() {
    let $this = this;
		const options = {
			// colors: $this.page_data['clients_managed']['colors'],
			series: $this.page_data['clients_managed']['y-axis'],
			chart: {
				type: 'pie',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 330,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				pie: {
					startAngle: 0
				}
			},
			dataLabels: {
				enabled: false,
			},
			labels: $this.page_data['clients_managed']['x-axis'],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
		};

		var chart = new ApexCharts(document.querySelector('#advisor-productivity-graph'), options);
		chart.render();
  }

  createClientEngagementGraph() {
		let $this = this;
		let options = {
			 colors: this.page_data['engagement_chart']['colors'],
      series: this.page_data['engagement_chart']['y-axis'],
      chart: {
        height: 300,
        type: 'line',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        curve: 'smooth',
        width: 3
      },
      fill: {
        type: 'solid',
        opacity: [0.2, 1],
      },
      labels: this.page_data['engagement_chart']['x-axis'],
      markers: {
        size: 0,
      },
      yaxis: [
        {
          title: {
            text: 'Count',
          },
          labels: {
            // formatter: function (value) {
            //   let val: string | number = Math.abs(value);
            //   if (val >= 10 ** 3 && val < 10 ** 6) {
            //     val = (val / 1000).toFixed(0) + 'K';
            //   } else if (val >= 10 ** 6) {
            //     val = (val / 1000000).toFixed(0) + 'M';
            //   } else {
            //     val = val;
            //   }
            //   return val;
            // },
            formatter: (value: number) => {
              return this.commonService.labelFormatter(value);
            }
          },
        },
        // {
        //   opposite: true,
        //   title: {
        //     text: '',
        //   },
        // },
      ],
      // tooltip: {
      //   shared: true,
      //   intersect: false,
      //   y: {
      //     formatter: function (y) {
      //       if(typeof y !== "undefined") {
      //         return  y.toFixed(0) + " points";
      //       }
      //       return y;
      //     }
      //   }
      // }
		};
		let chart = new ApexCharts(
			document.querySelector('#client-engagement-graph'),
			options,
		);
		chart.render();
	}

  createRevenueImpactGraph() {
    let $this = this;
    var options = {
      colors: ['#1B82EC', '#FFA724', '#91C906'],
      series: $this.page_data['revenue_stacked_chart']['y-axis'],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: $this.commonService.getBarGraphPercentWidth(
            document.getElementById('revenue-graph').clientWidth,
            $this.page_data['revenue_stacked_chart']['x-axis'].length,
            30,
          ),
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['revenue_stacked_chart']['x-axis'],
        title: {
          // text: 'Quarters',
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Amount',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return APP_CONSTANTS.CURRENCY_SYMBOL + ' ' + val.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#revenue-graph'),
      options,
    );
    chart.render();
  }

}
